import { Text } from '@mantine/core';

interface Props {
    label: string;
    children?: React.ReactNode;
}
export function TextLabelInputTradeView({ label, children }: Props) {
    return (
        <div className="textLabelInputContainerTradeView">
            <Text className="textLabelTradeView">
                {label}:
            </Text>
            <div className="textContentTradeView">
                {children || <Text className="placeholderTextTradeView"></Text>}
            </div>
        </div>
    );
} 